import { IAuthenticationService } from '../';
import { IFrequency, TimeUnit } from '../../models/index';
import { momentFormat } from '../../common/constants';

export interface IDateHelperFormatService {
    hasHour(freq: IFrequency): boolean;
    getDateFormat(): string;
}

export class DateHelperFormatService implements IDateHelperFormatService {
    static serviceId = 'dateHelperFormatService';

    static $inject = [
        'authenticationService',
        'currentApplicationService'
    ];
    constructor(private _authenticationService: IAuthenticationService) {
    }


    getDateFormat(): string {
        return this._authenticationService.authentication.datePickerFormat
            ? `${this._authenticationService.authentication.datePickerFormat} HH:mm`
            : momentFormat;
    }

    hasHour(freq: IFrequency): boolean {
        return (freq.intervalTimeUnit === TimeUnit.Hour)
            || (freq.intervalTimeUnit === TimeUnit.Minute);
    }
}